function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { Fragment } from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
import Typography from "@mui/material/Typography";
//Limitless imports
import { withi18n } from "../../../../../customer/components";
import { ExpertReviewSummary, getReviewSummaryDialogueText } from "../../../../../expert";
import ConversationPanelFooter from "../conversation-panel-footer/ConversationPanelFooter";
import PanelHeader from "../../panel-header/PanelHeader";
import ReviewSummary from "../../review-summary/ReviewSummary";
import ConversationTabContent from "../conversation-tab-content/ConversationTabContent";
const ConversationReviewPanel = ({
  t,
  classes
}) => {
  return /*#__PURE__*/React.createElement(ExpertReviewSummary, null, ({
    noOfDialoguesVoted,
    onFormSubmit,
    ...rest
  }) => {
    return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(PanelHeader, null, /*#__PURE__*/React.createElement(Typography, {
      color: "textPrimary",
      variant: "subtitle1"
    }, t("Review"))), /*#__PURE__*/React.createElement(ConversationTabContent, null, /*#__PURE__*/React.createElement("div", {
      className: classes.reviewPanelContainer
    }, /*#__PURE__*/React.createElement(Typography, {
      color: "textPrimary"
    }, t("Review other ambassador contribution to this task by selecting all dialogues you feel contributed to the successful resolution of this task")), /*#__PURE__*/React.createElement(Typography, {
      color: "textPrimary"
    }, t("You must endorse at least one dialogue and may endorse all dialogues.")), /*#__PURE__*/React.createElement(Typography, {
      color: "textPrimary",
      component: "span"
    }, t("If you feel you cannot endorse any dialogue, then either:"), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, t("Submit a new response for the customer or")), /*#__PURE__*/React.createElement("li", null, t("Report this message to Limitless")))), /*#__PURE__*/React.createElement(ReviewSummary, {
      t: t
    }, t(getReviewSummaryDialogueText(noOfDialoguesVoted), noOfDialoguesVoted)))), /*#__PURE__*/React.createElement(ConversationPanelFooter, _extends({
      onFinish: onFormSubmit,
      finishTooltip: "You must endorse at least one reply to finish this review",
      cancelTooltip: ""
    }, rest)));
  });
};
const styles = () => ({
  reviewPanelContainer: {
    display: "flex",
    flexDirection: "column",
    marginTop: 16,
    "& p, span": {
      marginBottom: 16
    }
  }
});
export default withStyles(styles)(withi18n(ConversationReviewPanel));
ConversationReviewPanel.propTypes = {
  t: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired
};